
import { Ban, UserMinus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UserActionsProps {
  onBan: () => void;
  onDelete: () => void;
  isRemoveFromGym?: boolean;
}

export const UserActions = ({ onBan, onDelete }: UserActionsProps) => {
  return (
    <div className="flex justify-end gap-2">
      <Button variant="outline" size="icon" onClick={onBan}>
        <Ban className="h-4 w-4" />
      </Button>
      <Button variant="destructive" size="icon" onClick={onDelete}>
        <UserMinus className="h-4 w-4" />
      </Button>
    </div>
  );
};
